import AppListing from '../app-components/Listing/AppListing';

Vue.component('admin-user-listing', {
    mixins: [AppListing],
    methods: {
        resendActivation(url) {
            axios.get(url).then(
                response => {
                    if(response.data.message) {
                        this.$notify({ type: 'success', title: 'Success', text: response.data.message});
                    } else if (response.data.redirect) {
                        window.location.replace(response.data.redirect);
                    }
                }
            ).catch(errors => {
                    if(errors.response.data.message) {
                        this.$notify({ type: 'error', title: 'Error!', text: errors.response.data.message})
                    }
                }
            );
        },
        impersonalLogin(url, item) {

            var _this7 = this;

            this.$modal.show('dialog', {
                title: 'Warning!',
                text: `Apakah Anda ingin login sebagai ${item.email}?`,
                buttons: [{ title: 'Tidak, batal.' }, {
                    title: `<span class="btn-dialog btn-warning">Ya, sebagai ${item.email}<span>`,
                    handler: function handler() {

                        _this7.$modal.hide('dialog');

                        axios.get(url).then(
                            response => {
                                if(response.data.message) {
                                    _this7.$notify({ type: 'success', title: 'Success', text: response.data.message});
                                    return setTimeout(() => {
                                        window.location.replace(response.data.path);
                                    }, 2000);
                                } 
                                
                                if(response.data.message) {
                                    _this7.$notify({ type: 'success', title: 'Success', text: response.data.message});
                                } else if (response.data.data.path) {
                                    window.location.replace(response.data.data.path);
                                }
                            }
                        ).catch(errors => {
                                if(errors.response.data.message) {
                                    _this7.$notify({ type: 'error', title: 'Error!', text: errors.response.data.message})
                                }
                            }
                        );

                    }
                }]
            });

            
        },
    },
    props: {
        'activation': {
            type: Boolean,
            required: true
        },
    }
});